import { useEffect } from 'react';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { PricingAmbassador, PricingComparison, PricingContact, PricingFAQ, PricingFeatures, PricingPlans } from '../../components/service/subscription';
export const PricingPageView = () => {
  const {
    user
  } = useAuth();
  useEffect(() => {
    logger.track('enter_pricing');
  }, []);
  return <>
      <PricingPlans data-sentry-element="PricingPlans" data-sentry-source-file="pricing.tsx" />
      {user?.isEdu && <PricingAmbassador />}
      <PricingFeatures data-sentry-element="PricingFeatures" data-sentry-source-file="pricing.tsx" />
      <PricingComparison data-sentry-element="PricingComparison" data-sentry-source-file="pricing.tsx" />
      <PricingFAQ data-sentry-element="PricingFAQ" data-sentry-source-file="pricing.tsx" />
      <PricingContact data-sentry-element="PricingContact" data-sentry-source-file="pricing.tsx" />
    </>;
};